import React, { useState, useEffect, Fragment } from 'react';
import services from '../service';
import { validateProperty, validate } from "../../Common"
import MessageModal from '../../../UI/Modal/MessageModal';
import Joi from '@hapi/joi'
import { PageHeader } from '../../../Common';
import TextField from '@material-ui/core/TextField';
import groupService from '../../Group/services';
import { VehicleSchemaObject } from '../VehicleSchema';
import FormHelperText from '@material-ui/core/FormHelperText';
import { trackPromise } from 'react-promise-tracker';
import { LoadingSpinerComponent } from '../../../Common/loader'
import authService from '../../Common/services';
import tokenService from '../../../Common/tokenDecoder';
import { CommonDecryptParam } from '../../../../utils/CommonParams';
const screenCode = 'VIEWVEHICLEREGISTRATION';
export function VehicleCardAddEdit(props) {
    const { data, edit } = props.location
    const [selectedOptions, setSelectedOptions] = useState([]);
    const getOptionLabel = option => `${option.label}`;
    const getOptionDisabled = option => option.value === "foo";
    const handleToggleOption = selectedOptions => setSelectedOptions(selectedOptions);
    const { screen } = props.location;
    const [title, setTitle] = useState("Add Vehicle");
    const [buttonName, setButtonName] = useState("Save")
    const [groups, setGroups] = useState([]);
    const [operationEntity, setOperationEntity] = useState();
    const [isEditScreen, setIsEditScreen] = useState(false);
    const [vehicleRegistration, setVehicleRegistration] = useState({
        groupID: '0',
        operationEntityID: '0',
        vehicleTypeID: '0',
        vehicleRegistrationNumber: '',
        fuelTypeID: '0',
        capacity: '',
        vehicleID: '0',

    });

    const [errors, setErrors] = useState({});
    const [messageModel, setMessageModel] = useState({
        hidden: true,
        type: "Success",
        disciption: "Save/ Edit success"
    });
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false
    });
    const encriptedTest = props.match.params["id"];
    const id = (encriptedTest !== undefined) ? CommonDecryptParam(props.match.params["id"]) : 0;

    const schema = Joi.object(VehicleSchemaObject).options({ allowUnknown: true })

    useEffect(() => {
        trackPromise(
            getPermissions(),
        )
    }, []);

    useEffect(() => {
        trackPromise(
            getOperationEntitiesForDropdown()
        )
    }, [vehicleRegistration.groupID])

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'ADDEDITVEHICLEREGISTRATION');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }

        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !== undefined
        });

        var token = tokenService.getUserDetailsFromToken();
        setVehicleRegistration({
            ...vehicleRegistration,
            groupID: token.groupID,
            operationEntityID: token.operationEntityID,
            vehicleTypeID: token.vehicleTypeID,
            vehicleRegistrationNumber: token.vehicleRegistrationNumber,
            fuelTypeID: token.fuelTypeID,
            capacity: token.capacity,
            vehicleID: token.vehicleID,
        });

        getGroupsForDropdown();

        if (data && edit) {
            setTitle("Edit Vehicle Registration");
            setButtonName("Update");
            setVehicleRegistration(data)
            setIsEditScreen(true);

        } else {
            setTitle("Add vehicle Registration");
            var token = tokenService.getUserDetailsFromToken();
            setVehicleRegistration({
                ...vehicleRegistration,
                groupID: token.groupID,
                operationEntityID: token.operationEntityID
            });
        }

    }
    async function getGroupsForDropdown() {
        const groups = await groupService.getGroupsForDropdown();
        setGroups(groups);
    }


    async function getOperationEntitiesForDropdown() {
        const operationEntity = await services.GetAllOperationEntityByGroupID(vehicleRegistration.groupID);
        setOperationEntity(operationEntity);
    }
    function generateDropDownMenu(data) {
        let items = [];
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<option key={key} value={key}>{value}</option>);
            }
        }
        return items;
    }

    function handleChange(e) {

        const target = e.target
        const value = target.name === 'isSupplementary' ? target.checked : target.value;

        const error = { ...errors }
        const errorMessage = validateProperty(target, VehicleSchemaObject)
        errorMessage ? error[target.name] = errorMessage : delete error[target.name]

        setVehicleRegistration({
            ...vehicleRegistration,
            [e.target.name]: value
        });

        setErrors(error);
    }
    async function handleFuelTypeChange(e) {
        setVehicleRegistration({
            ...vehicleRegistration,
            fuelTypeID: e.target.value

        });
    }
    async function handleSave(e) {
        e.preventDefault();

        const errorMessages = validate(schema, vehicleRegistration);
        errorMessages !== null ? setErrors(errorMessages) : setErrors({});

        if (errorMessages) return
        var vehicleRegistrationDetails = {
            vehicleID: (data && edit) ? parseInt(vehicleRegistration.vehicleID) : 0,
            groupID: parseInt(vehicleRegistration.groupID),
            operationEntityID: parseInt(vehicleRegistration.operationEntityID),
            vehicleTypeID: parseInt(vehicleRegistration.vehicleTypeID),
            vehicleRegistrationNumber: vehicleRegistration.vehicleRegistrationNumber,
            fuelTypeID: parseInt(vehicleRegistration.fuelTypeID),
            capacity: parseFloat(vehicleRegistration.capacity),

        }
        let response;
        if (!edit) {
            response = await services.saveVehicleRegistration(vehicleRegistrationDetails);


        } else {
            response = await services.updateVehicleRegistration(vehicleRegistrationDetails);

        }

        setMessageModel({ ...messageModel, hidden: false, type: response.statusCode, disciption: response.message })
        afterSuccessfulyChanged(response.statusCode)
    }

    function afterSuccessfulyChanged(response) {
        if (response === "Success") {
            clearState()
            setTimeout(() => {
                props.history.push({ pathname: '/vehicleRegistration' });

                props.history.go();
            }, 1500);

        }
    }

    function modalDismissHandler() {
        setMessageModel({ ...messageModel, hidden: true })
    }

    function clearState() {
        var token = tokenService.getUserDetailsFromToken();
        setErrors({});
        setVehicleRegistration({
            ...vehicleRegistration,
            groupID: !permissionList.isGroupFilterEnabled ? '0' : token.groupID,
            operationEntityID: !permissionList.isOperationEntityFilterEnabled ? '0' : token.operationEntityID,
            vehicleTypeID: '0',
            vehicleRegistrationNumber: '',
            fuelTypeID: '0',
            capacity: '',
            vehicleID: '0',
        })
    }
    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div>
                        <div className="card">
                            <PageHeader
                                title={title}
                                isButtonEnable={true}
                                buttonText="Back to Listing"
                                path={screen === "vehicleRegistration" || screen === undefined ? "/vehicleRegistration" : "/vehicleRegistration"}
                            />
                            <div className="card-body">
                                <div className="row row-top-gap">
                                    <div className="col-md-4 pb-1">
                                        <TextField select fullWidth
                                            label="Group *"
                                            id="groupID"
                                            name="groupID"
                                            value={vehicleRegistration.groupID}
                                            onChange={(e) => handleChange(e)}>
                                            <option value="0">--Select Group--</option>
                                            {generateDropDownMenu(groups)}
                                        </TextField>
                                        {errors["groupID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["groupID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md-4 pb-1">
                                        <TextField select fullWidth
                                            label="Estate *"
                                            id="operationEntityID"
                                            name="operationEntityID"
                                            value={vehicleRegistration.operationEntityID}
                                            onChange={(e) => handleChange(e)}>
                                            <option value="0">--Estate--</option>
                                            {generateDropDownMenu(operationEntity)}
                                        </TextField>
                                        {errors["operationEntityID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["operationEntityID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md-4 pb-1">
                                        <TextField select fullWidth
                                            label="Vehicle Type *"
                                            id="vehicleTypeID;"
                                            name="vehicleTypeID"
                                            value={vehicleRegistration.vehicleTypeID}
                                            onChange={(e) => handleChange(e)}>
                                            <option value="0">--Select Vehicle Type--</option>
                                            <option value="1">Car</option>
                                            <option value="2">Van</option>
                                            <option value="3">three weel</option>
                                            <option value="4">lorry</option>
                                        </TextField>
                                        {errors["vehicleTypeID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["vehicleType"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md-4 pb-1">
                                        <TextField fullWidth label="Vehicle Registration Number *"
                                            name="vehicleRegistrationNumber"
                                            id="vehicleRegistrationNumber"
                                            value={vehicleRegistration.vehicleRegistrationNumber}
                                            type="text"
                                            onChange={(e) => handleChange(e)} />
                                        {errors["vehicleRegistrationNumber"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["vehicleRegistrationNumber"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md-4 pb-1">
                                        <TextField select fullWidth
                                            label="Fuel Type *"
                                            id="fuelType;"
                                            name="fuelType"
                                            value={vehicleRegistration.fuelTypeID}
                                            onChange={(e) => handleFuelTypeChange(e)}>
                                            <option value="0">--Select Fuel Type--</option>
                                            <option value="1">Diesal</option>
                                            <option value="2">Petrol</option>
                                        </TextField>
                                    </div>
                                    <div className="col-md-4 pb-1">
                                        <TextField fullWidth label="Capacity *"
                                            name="capacity"
                                            id="capacity"
                                            value={vehicleRegistration.capacity}
                                            type="text"
                                            onChange={(e) => handleChange(e)} />
                                        {errors["capacity"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["capacity"]}</FormHelperText>}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <input
                            type="submit"
                            className="btn btn-primary"
                            onClick={handleSave}
                            value={buttonName}
                        />
                        <input type="reset" className="btn btn-warning pull-right"
                            onClick={clearState}
                            value="Clear" />
                    </div>
                    <MessageModal
                        hidden={messageModel.hidden}
                        messageType={messageModel.type}
                        messageDescription={messageModel.disciption}
                        clicked={modalDismissHandler}
                    />
                </div>
            </div>
        </Fragment >
    );
}